<!-- Configurable View Container -->
<div
    class="tw-flex tw-h-full tw-flex-col tw-py-6 tw-max-h-[calc(100vh-200px)] tw-overflow-hidden">
    <!-- Header Section with View Toggle and Actions -->
    <div
        class="tw-grid tw-auto-rows-auto tw-grid-cols-12 tw-gap-6 tw-px-2 xl:tw-grid-rows-1 xl:tw-px-6 tw-flex-shrink-0">
        <!-- Filter Section -->
        @if (filterConfig()) {
            <div class="tw-order-1 tw-col-span-12">
                <app-paginated-table-filter
                    [keysForFilteringObj]="filterConfig()!.filterKeys"
                    [showClosedLabel]="
                        filterConfig()!.showClosedToggle
                            ? 'GENERAL.SHOW-CLOSED'
                            : null
                    "
                    [totalItems]="totalItems()"
                    [userRole]="userRole"
                    [shouldShowLocationFilter]="shouldShowLocationFilter()"
                    [shouldShowColumnFilter]="shouldShowColumnFilter()"
                    [filteredLocationsCount]="filteredLocationsCount()"
                    [isLocationFilterActive]="isLocationFilterActive()"
                    [headerActions]="headerActions()"
                    [currentSelection]="selectedItems()"
                    (locationFilterClicked)="onLocationFilterClick()"
                    (columnFilterClicked)="onColumnFilterClick()"
                    (headerActionClicked)="onHeaderActionClick($event)">
                </app-paginated-table-filter>
            </div>
        }
    </div>

    <!-- Table Section -->
    <div class="tw-flex-1 tw-overflow-hidden tw-min-h-0">
        <!-- Generic Table Component - Hidden when share permissions dialog is open -->
        @if (!isSharePermissionsDialogOpen()) {
            <app-generic-table
                [data]="data()"
                [columns]="tableColumns()"
                [config]="currentConfig()?.tableConfig"
                [loading]="loading()"
                [error]="error()"
                [sortable]="
                    currentConfig()?.tableConfig?.features?.sortable || false
                "
                [filterable]="
                    currentConfig()?.tableConfig?.features?.filterable || false
                "
                [paginated]="
                    currentConfig()?.tableConfig?.features?.paginated || false
                "
                [tableClass]="
                    currentConfig()?.tableConfig?.cssClasses?.table || ''
                "
                [emptyStateMessage]="'GENERAL.NO-DATA'"
                [showFilter]="true"
                [showPagination]="shouldShowPagination()"
                (sortChange)="onSortChange($event)"
                (pageChange)="onPageChange($event)"
                (selectionChange)="onSelectionChange($event)"
                (rowExpand)="onRowExpand($event)"
                (refresh)="onRefresh()">
            </app-generic-table>
        }

        <!-- Placeholder when share permissions dialog is open -->
        @if (isSharePermissionsDialogOpen()) {
            <div
                class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-h-64 tw-text-center tw-bg-gray-50 tw-rounded-lg">
                <div class="tw-text-gray-400 tw-text-sm">
                    {{ 'GENERAL.TABLE_TEMPORARILY_HIDDEN' | translate }}
                </div>
            </div>
        }
    </div>
</div>
